import { render, staticRenderFns } from "./MobileMangaReloadForm.vue?vue&type=template&id=8bc96502&scoped=true&"
import script from "./MobileMangaReloadForm.vue?vue&type=script&lang=js&"
export * from "./MobileMangaReloadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc96502",
  null
  
)

export default component.exports